// extracted by mini-css-extract-plugin
module.exports = {"AboutPageLayout":"AboutPageLayout","App__Main":"App__Main","BlockContainer":"BlockContainer"};